import React, { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Real Project Data
const projects = [
    {
        id: 1,
        title: "Valar Pay",
        category: "FinTech Solution",
        url: "https://valarpay.com/",
        description: "Secure and seamless digital payment infrastructure for modern businesses.",
        fallbackColor: "#f76301" // Updated as requested
    },
    {
        id: 2,
        title: "Sagama Homes",
        category: "Real Estate",
        url: "http://sagamahomes.com/",
        description: "Premium real estate platform connecting buyers with their dream properties.",
        fallbackColor: "#ff5e14" // Updated as requested
    },
    {
        id: 3,
        title: "Brave Rock",
        category: "Construction & Engineering",
        url: "https://braverockltd.com/",
        description: "Corporate portfolio for a leading construction and engineering firm.",
        fallbackColor: "#f1c81b" // Updated as requested
    },
    {
        id: 4,
        title: "Natty Pay",
        category: "Digital Finance",
        url: "https://nattypay.com/",
        description: "Next-gen mobile payment solution for fast and secure transactions.",
        fallbackColor: "#d4b139" // Updated as requested
    },
    {
        id: 5,
        title: "Rebate Board",
        category: "E-Commerce",
        url: "http://rebateboard.com/",
        description: "Deal discovery platform offering the best rebates and discounts.",
        fallbackColor: "#833af6" // Updated as requested
    },
    {
        id: 6,
        title: "Padi Jobs",
        category: "Recruitment",
        url: "http://padijobs.com/",
        description: "Connecting talented professionals with top employers across industries.",
        fallbackColor: "#e72028" // Updated as requested
    },
    {
        id: 7,
        title: "Tegal App",
        category: "Mobile Application",
        url: "https://tegalapp.com/",
        description: "Innovative mobile utility application designed for user productivity.",
        fallbackColor: "#e91f63" // Updated as requested
    }
];

const BrowserMockup = ({ project }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        window.open(project.url, "_blank");
    };

    const screenshotUrl = `https://api.microlink.io/?url=${encodeURIComponent(project.url)}&screenshot=true&meta=false&embed=screenshot.url`;

    return (
        <div className="portfolio-slide-item" style={{ padding: '0 8px', paddingBottom: '30px' }}>
            <div
                onClick={handleClick}
                className="browser-mockup"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    background: '#fff',
                    borderRadius: '12px',
                    boxShadow: isHovered
                        ? '0 30px 60px -12px rgba(0, 0, 0, 0.45)'
                        : '0 10px 30px -5px rgba(0, 0, 0, 0.25)',
                    transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
                    transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
                    overflow: 'hidden',
                    border: '1px solid #2d3748',
                    position: 'relative',
                    height: '420px',
                    display: 'flex',
                    flexDirection: 'column',
                    cursor: 'pointer'
                }}
            >
                {/* Browser Header */}
                <div style={{
                    padding: '12px 16px',
                    background: '#1a202c',
                    borderBottom: '1px solid #2d3748',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    zIndex: 2,
                    position: 'relative'
                }}>
                    {/* Traffic Lights */}
                    <div style={{ display: 'flex', gap: '6px' }}>
                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#ef4444' }}></div>
                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#f59e0b' }}></div>
                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#22c55e' }}></div>
                    </div>

                    {/* Address Bar */}
                    <div style={{
                        flex: 1,
                        background: '#2d3748',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        fontSize: '12px',
                        color: '#a0aec0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontFamily: 'monospace'
                    }}>
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.5 }}>
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>
                        <span style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            opacity: 0.8
                        }}>
                            {project.url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')}
                        </span>
                    </div>
                </div>

                {/* Viewport Content */}
                <div style={{
                    flex: 1,
                    position: 'relative',
                    background: '#f8fafc',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <img
                            src={screenshotUrl}
                            alt={`${project.title} Preview`}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'top center',
                                transition: 'transform 2s ease',
                                transform: isHovered ? 'scale(1.1) translateY(0%)' : 'scale(1) translateY(0%)'
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.style.background = `linear-gradient(135deg, ${project.fallbackColor} 0%, #ffffff 100%)`;
                            }}
                        />
                    </div>

                    {/* Overlay Info */}
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        padding: '25px',
                        background: 'rgba(26, 32, 44, 0.95)',
                        borderTop: '1px solid #ffc107',
                        transform: isHovered ? 'translateY(0)' : 'translateY(100%)',
                        opacity: isHovered ? 1 : 0,
                        transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        zIndex: 10
                    }}>
                        <div>
                            <div style={{
                                color: '#ffc107',
                                fontSize: '11px',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                marginBottom: '4px',
                                letterSpacing: '0.05em'
                            }}>
                                {project.category}
                            </div>
                            <h3 style={{ color: '#fff', fontSize: '18px', margin: 0, fontWeight: 700 }}>{project.title}</h3>
                        </div>
                    </div>

                    <div style={{
                        position: 'absolute',
                        bottom: '30px',
                        left: '0',
                        right: '0',
                        textAlign: 'center',
                        opacity: isHovered ? 0 : 1,
                        transition: 'opacity 0.2s ease',
                        transform: 'translateY(0)'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#fff',
                            margin: 0,
                            background: project.fallbackColor,
                            padding: '6px 20px',
                            borderRadius: '100px',
                            display: 'inline-block',
                            boxShadow: `0 4px 15px ${project.fallbackColor}66` // Adding opacity to shadow color
                        }}>{project.title}</h3>
                    </div>

                </div>
            </div>
        </div>
    );
};

const PortfolioSection = () => {
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 1,
        rows: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    rows: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 1,
                }
            }
        ]
    };

    return (
        <section style={{
            padding: '80px 0 140px 0',
            position: 'relative',
            overflow: 'hidden'
        }}>

            <div className="container" style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 30px', position: 'relative', zIndex: 10 }}>
                {/* Section Header */}
                <div style={{ textAlign: 'center', marginBottom: '70px' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 20px',
                        background: '#1a202c',
                        border: '1px solid #2d3748',
                        borderRadius: '0px', // Sharp corners for "cutting" look
                        marginBottom: '20px',
                        transform: 'skewX(-10deg)' // Angular style
                    }}>
                        <span style={{
                            fontSize: '12px',
                            fontWeight: 700,
                            color: '#ffc107',
                            textTransform: 'uppercase',
                            letterSpacing: '0.1em',
                            transform: 'skewX(10deg)' // Fix text skew
                        }}>
                            Our Portfolio
                        </span>
                    </div>
                    <h2 style={{ fontSize: '48px', fontWeight: 800, color: '#1a202c', marginBottom: '16px', letterSpacing: '-0.03em' }}>
                        Recent Projects
                    </h2>
                    <p style={{ fontSize: '19px', color: '#4a5568', maxWidth: '640px', margin: '0 auto', lineHeight: 1.6 }}>
                        We've helped these amazing companies launch, scale, and transform their digital presence.
                    </p>
                </div>

                {/* Portfolio Slider */}
                <div className="portfolio-slider-container">
                    <Slider {...sliderSettings}>
                        {projects.map((project, index) => (
                            <BrowserMockup key={project.id} project={project} />
                        ))}
                    </Slider>
                </div>

                {/* View All Button Removed */}
            </div>

            <style>{`


                .view-all-btn:hover {
                    background: #fff !important;
                    transform: translateY(-2px);
                }
                
                /* Slider Arrows */
                .slick-prev:before, .slick-next:before {
                    color: #1a202c !important;
                    font-size: 30px;
                    opacity: 1;
                }
                .slick-prev { left: -40px; }
                .slick-next { right: -40px; }
                
                @media (max-width: 768px) {
                    h2 { font-size: 36px !important; }
                    .slick-prev, .slick-next { display: none !important; }
                }
            `}</style>
        </section>
    );
};
export default PortfolioSection;
